import * as React from 'react';
import { Group, Text, Box, createStyles } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

const useStyles = createStyles((theme) => ({
    container: {
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        color: theme.colors.orange[6],
        background: theme.colors.orange[0],
        flexWrap: 'nowrap'
    },
    text: {
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'space-between',
        flexGrow: 1
    },
    iconBox: {
        width: '1rem',
        height: '1rem',
        // paddingTop: '5px',
        display: 'flex'
    }
}));

interface CardBannerProps {
    children: React.ReactNode;
}

export const CardBanner: React.FC<CardBannerProps> = ({ children, ...props }) => {
    const { cx, classes } = useStyles();

    return (
        <Group className={classes.container} {...props}>
            <Box className={classes.iconBox}>
                <IconAlertCircle size="1rem" />
            </Box>
            <Text className={classes.text}>{children}</Text>
        </Group>
    );
};
